import { Editor } from 'slate';
import { getListItemsInRange, getPrevSibling, pickSubtreesRoots } from "../lib/index.js";
import { ListType } from "../types.js";
import { increaseListItemDepth } from "./increaseListItemDepth.js";
import { wrapInList } from "./wrapInList.js";
/**
 * Increases nesting depth of all "list-items" in the current selection.
 * All nodes matching options.wrappableTypes in the selection will be converted to "list-items" and wrapped in a "list".
 */
export function increaseDepth(editor) {
  if (!editor.selection) {
    return;
  }
  var listItems = getListItemsInRange(editor, editor.selection);
  var indentableListItems = listItems.filter(_ref => {
    var [, listItemPath] = _ref;
    var previousListItem = getPrevSibling(editor, listItemPath);
    return previousListItem !== null;
  });

  // When calling `increaseListItemDepth` the paths and references to list items
  // can change, so we need a way of marking the list items scheduled for transformation.
  var refs = pickSubtreesRoots(indentableListItems).map(_ref2 => {
    var [_, path] = _ref2;
    return Editor.pathRef(editor, path);
  });
  Editor.withoutNormalizing(editor, () => {
    // Before we indent "list-items", we want to convert every non list-related block in selection to a "list".
    wrapInList(editor, ListType.UNORDERED);
    refs.forEach(ref => {
      if (ref.current) {
        increaseListItemDepth(editor, ref.current);
      }
      ref.unref();
    });
  });
}